import { InjectionToken } from '@angular/core';
import { ShellOptions, ComponentMap } from './interfaces';

const COMPONENT_REGISTRY = new InjectionToken<ComponentMap[]>('Component Registry');
const SHELL_DEFAULT_OPTIONS = new InjectionToken<ShellOptions>('Shell Default Options');
const WINDOW_DATA = new InjectionToken<any>('Window Data');
const WINDOW_REF = new InjectionToken<any>('Window Reference');

export {
  COMPONENT_REGISTRY,
  SHELL_DEFAULT_OPTIONS,
  WINDOW_DATA,
  WINDOW_REF,
}
